import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=7607bf51&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DownloadButton.vue?vue&type=style&index=0&id=7607bf51&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7607bf51",
  "3000d84b"
  
)

export default component.exports